import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Table, Tag } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { menuHelper } from '../../../helpers/account';
import { ContentHeader } from '../../../components';
import { Links } from '../../../helpers/Links';
import { layDsKhenThuongNhanSuKhac } from '../../../services/nhansukhac';
import { DanhSachKhenThuongNhanSuKhacResponse } from '../../../models/nhansukhac/NhanSuKhac';

const DanhSachKhenThuongNhanSuKhac = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<Array<DanhSachKhenThuongNhanSuKhacResponse>>();
    const menu: any = menuHelper.checkMultiPermission([Links.NhanSuKhac.LuongKhenThuong, Links.NhanSuKhac.ChiTietLuongKhenThuong]);

    const layDuLieu = async (tuKhoa: string) => {
        try {
            setIsLoading(true);
            var rs = await layDsKhenThuongNhanSuKhac(tuKhoa);
            setDataTable((rs || []).map((v: DanhSachKhenThuongNhanSuKhacResponse) => { return { ...v, key: v.id } }));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        layDuLieu("");
    }, [])

    return (
        <section>
            <ContentHeader title="Danh sách khen thưởng" />
            <Row className="mb-2">
                <Col span="6">
                    <Input
                        allowClear
                        prefix=<SearchOutlined rev="" />
                        placeholder="Tìm kiếm"
                        onChange={(e) => {
                            layDuLieu(e.target.value);
                    }} />
                </Col>
                <Col span="18">
                    {
                        menu[Links.NhanSuKhac.ChiTietLuongKhenThuong] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.NhanSuKhac.ChiTietLuongKhenThuong}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Tên" dataIndex="ten" key="ten" />
                            <Column title="Số lượng nhân sự" dataIndex="soLuongCBCNV" key="soLuongCBCNV" />
                            <Column title="Trạng thái" dataIndex="khoaDieuChinh" key="khoaDieuChinh" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="success">Khởi tạo</Tag>); break;
                                    case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.NhanSuKhac.ChiTietLuongKhenThuong] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.NhanSuKhac.ChiTietLuongKhenThuong + "?id=" + record.id}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachKhenThuongNhanSuKhac;